{
  "title": "Resident pages",
  "heading": "Log in",
  "username": "Email address",
  "password": "Password",
  "error": "Error logging in",
  "submit": "Log in",
  "forgotPasswordButtonText": "Forgotten your password?",
  "errors": {
    "loginExpired": "Your login has expired. Please log in again.",
    "userAlreadyRegistered": "A user with the same username already exists {{email}}. You can reset your password using the ‘forgot password' function.",
    "noTenantFound": "No agreements can be found for the identified user."
  }
}
